<nav

class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
id="layout-navbar"
style="background-color: #800000;"
>


<a class="nav-item nav-link px-0 me-xl-4 d-xl-none" href="javascript:void(0)"
   (click)="toggleSidebar()">
  <i class="bx bx-menu bx-sm"></i>
</a>
<div  class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">


  <ul class="navbar-nav flex-row align-items-center ms-auto">
    <!-- Place this tag where you want the button to render. -->


  

    <!-- User -->
    <li class="nav-item navbar-dropdown dropdown-user dropdown" [class.show]="isDropdownOpen">
      <a class="nav-link dropdown-toggle hide-arrow show" href="javascript:void(0);" data-bs-toggle="dropdown" (click)="toggleDropdown()">
        <div class="avatar avatar-online">
          <img src="assets/img/avatars/Vector.png" alt class="w-px-40 h-auto rounded-circle" />
        </div>
      </a>
      <ul class="dropdown-menu dropdown-menu-end" [class.show]="isDropdownOpen">
        <li>
          <a class="dropdown-item">
            <div class="d-flex">
              <div class="flex-shrink-0 me-3">
                <div class="avatar avatar-online">
                  <img src="assets/img/avatars/Vector.png" alt class="w-px-40 h-auto rounded-circle" />
                </div>
              </div>
              <div class="flex-grow-1">
                <span class="fw-semibold d-block">Admin</span>
                <!-- <small class="text-muted">Admin</small> -->
              </div>
            </div>
          </a>
        </li>
        <li>
          <div class="dropdown-divider"></div>
        </li>
        <li (click)="basicSetting()" >
        
            <a class="dropdown-item"  [routerLink]="['basic-setting']" >
            <i class="bx bx-user me-2"></i>
            <span class="align-middle">基本設定</span>
          </a>
        </li>     
        <li>
          <div class="dropdown-divider"></div>
        </li>
        <li>
          <a class="dropdown-item" href="#" (click)="logout()">
            <i class="bx bx-power-off me-2"></i>
            <span class="align-middle">Log Out</span>            
          </a>         

        </li>
      </ul>
    </li>
    <!--/ User -->
  </ul>
</div>
</nav>
